export default "__VITE_ASSET__GZKmngZ0__"